import {SearchType} from "../Model/SearchType";
import {BoundsKeyWordSearchService} from "./BoundsKeyWordSearchService.js";
import {BusPlanSuggestKeyWordSearchService} from "./BusPlanSuggestKeyWordSearchService";
import {CenterPointKeyWordSearchService} from "./CenterPointKeyWordSearchService.js";
import {LocalKeyWordSearchService} from "./LocalKeyWordSearchService";
import {KeyWordSuggestSearchService} from "./KeyWordSuggestSearchService";
import {PurePOIkeyWordSearchService} from "./PurePOIkeyWordSearchService";
import {ViewKeyWordSearchService} from "./ViewKeyWordSearchService";


export class KeyWordSearchServiceFactory
{   
    constructor()
    {

    }

    /**
	 * 通过搜索类型获得关键字搜索服务
	 * @param searchType 搜索类型SearchType
	 * @return 
	 * 注：当searchType为SearchType.CenterPoint时，需要额外设置属性（centerPointX、centerPointY。radiusDistance）
	 */
	static GenerateKeyWordSearchService(searchType) {
		let keywordService = null;
		switch (searchType) {
			case SearchType.Bounds:
				keywordService = new BoundsKeyWordSearchService();
				break;
			case SearchType.BusPlanSuggest:
				keywordService = new BusPlanSuggestKeyWordSearchService();
				break;
			case SearchType.CenterPoint:
				keywordService = new CenterPointKeyWordSearchService();
				break;
			case SearchType.Common:
				keywordService = new LocalKeyWordSearchService();
				break;
			case SearchType.CommonSuggest:
				keywordService = new KeyWordSuggestSearchService();
				break;
			case SearchType.PurePOI:
				keywordService = new PurePOIkeyWordSearchService();
				break;
			case SearchType.View:
				keywordService = new ViewKeyWordSearchService();
				break;
			default:
				break;
		}
		keywordService.queryType = searchType;
		return keywordService;
	}


}